module.exports = __webpack_public_path__ + "static/media/service2.cd60fc54.png";